import React from 'react';

import { Form as FormShared } from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/$components';
import { Box, InputField, InputSelect, Spacer, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { rem } from '@helpers';
import { Anything, IntegratorEnum } from '@types';

import { useIntegratorFormHelper } from './integratorForm.helper';

// to fix not exists children prop in react-18
const Form = FormShared as any;

export const IntegratorForm: React.FC = () => {
	const {
		resources,
		colorPalette,
		form,
		selectedIntegrator,
		selectedOtherOrNewIntegrator,
		phoneCodes,
		popupMenuCountryRef,
		phoneFlagId,
		maxLengthContact,
		handlePressIndicative,
		getInputProps,
		onClearCorporateName,
		onClearInterlocutorName,
		onClearInterlocutorEmail,
		onClearInterlocutorContact,
	} = useIntegratorFormHelper();

	return (
		<Form name={form.name} ref={form.ref} style={{ flexDirection: 'column' }}>
			<Spacer vertical={rem(32)} />
			<Typography appearance="subtitle-100-03">{resources.contact}</Typography>
			<Spacer vertical={rem(16)} />
			{selectedOtherOrNewIntegrator ? (
				<Box
					styles={{
						backgroundColor: colorPalette.color_01[50],
						padding: '24px',
						boxShadow: '0px 2px 4px #E8EDF2',
						borderRadius: '16px',
						whiteSpace: 'nowrap',
					}}
				>
					<Box styles={{ width: '100%', flexDirection: 'column' }}>
						{selectedIntegrator?.code === IntegratorEnum.Other && (
							<>
								<Box styles={{ width: '66.5%', paddingRight: rem(10) }}>
									<InputField
										mode="default"
										label={resources.inputCorporateName}
										onClearButtonPress={onClearCorporateName}
										{...(getInputProps('corporateName') as Anything)}
									/>
								</Box>
								<Spacer vertical={rem(16)} />
							</>
						)}
						<Box styles={{ width: '100%', gap: rem(8) }}>
							<Box styles={{ width: '33%' }}>
								<InputField
									mode="default"
									label={resources.inputInterlocutorName}
									onClearButtonPress={onClearInterlocutorName}
									{...(getInputProps('interlocutorName') as Anything)}
								/>
							</Box>

							<Box styles={{ width: '33%' }}>
								<InputField
									mode="default"
									label={resources.inputInterlocutorEmail}
									onClearButtonPress={onClearInterlocutorEmail}
									{...(getInputProps('interlocutorEmail') as Anything)}
								/>
							</Box>

							<Box styles={{ width: '13%' }}>
								<InputSelect
									ref={popupMenuCountryRef}
									mode="default"
									inputField={{ label: resources.inputCountry }}
									startIcon={phoneCodes[phoneFlagId].leftIcon?.icon?.source}
									onPress={handlePressIndicative}
									popupMenu={{
										popupMenuHeight: { maxHeight: rem(150) },
										hideOnClick: true,
										items: phoneCodes,
										zIndex: 10,
									}}
								/>
							</Box>

							<Box styles={{ width: '20%' }}>
								<InputField
									mode="number"
									label={resources.inputContact}
									inputProps={{
										maxLength: maxLengthContact,
									}}
									onClearButtonPress={onClearInterlocutorContact}
									{...(getInputProps('interlocutorContact') as Anything)}
								/>
							</Box>
						</Box>
					</Box>
				</Box>
			) : (
				<Box
					styles={{
						width: rem(343),
					}}
				>
					<InputField
						mode="default"
						label={resources.inputTechnicalInterlocutorEmail}
						onClearButtonPress={onClearInterlocutorEmail}
						{...(getInputProps('interlocutorEmail') as Anything)}
					/>
				</Box>
			)}
		</Form>
	);
};
